import { Component, OnInit ,Input,Injectable} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import moment from 'moment';
import { CustomProductsService } from 'src/app/modules/custom-landing/custom-products/custom-products.service';
import { NgbActiveModal, NgbModal, NgbModalRef, NgbCalendar, NgbDate, NgbDateAdapter, NgbDateParserFormatter, NgbDatepickerConfig, NgbDatepickerI18n, NgbDateStruct, NgbInputDatepicker } from '@ng-bootstrap/ng-bootstrap';
import { CustomMyqoutesComponent } from 'src/app/modules/custom-landing/custom-myqoutes/custom-myqoutes.component';
import { EditConfirmBidComponent } from 'src/app/shared/components/edit-confirm-bid\/edit-confirm-bid.component';
import { NgIf, NgFor, DecimalPipe, DatePipe } from '@angular/common';
import { CopyDirective, CommonDigitsDirective, TwoDigitDecimaNumberDirective } from '../two-digit-decima-number.directive';
import { I18nModule } from '@spartacus/core';
@Injectable()
export class CustomAdapter extends NgbDateAdapter<string> {
	readonly DELIMITER = '-';

	fromModel(value: string | null): NgbDateStruct | null {
		if (value) {
			const date = value.split(this.DELIMITER);
			return {
				day: parseInt(date[0], 10),
				month: parseInt(date[1], 10),
				year: parseInt(date[2], 10),
			};
		}
		return null;
	}

	toModel(date: NgbDateStruct | null): string | null {
		return date ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year : null;
	}
}

/**
 * This Service handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
 */
@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
	readonly DELIMITER = '/';

	parse(value: string): NgbDateStruct | null {
		if (value) {
			const date = value.split(this.DELIMITER);
			return {
				day: parseInt(date[0], 10),
				month: parseInt(date[1], 10),
				year: parseInt(date[2], 10),
			};
		}
		return null;
	}

	format(date: NgbDateStruct | null): string {
		return date ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year : '';
	}
}
@Component({
    selector: 'app-edit-bid-modal',
    templateUrl: './edit-bid-modal.component.html',
    styleUrls: ['./edit-bid-modal.component.scss'],
    providers: [
        { provide: NgbDateAdapter, useClass: CustomAdapter },
        { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
    ],
    imports: [NgIf, FormsModule, NgFor, ReactiveFormsModule, NgbInputDatepicker, CopyDirective, CommonDigitsDirective, TwoDigitDecimaNumberDirective, DecimalPipe, DatePipe, I18nModule]
})
export class EditBidModalComponent implements OnInit {
  QPstartDate: NgbDate = null;
  QPendDate: NgbDate = null;
  nextMonth: string;
  preMonth: string;
  selectMonth: string;
  selectYear: string;
  form: UntypedFormGroup;
  @Input() qpStartDt;
  @Input() qpEndDt;
  qpSD:any;
  qpED:any;
  finalQPFromoDateErr:boolean=false;
finalQPToDateErr:boolean=false
isFinalQPFromDateValid:boolean=false
isFinalQPToDateValid:boolean=false
isFinalQPToGreater:boolean=false
convertedDate: any;
  hoveredDate: NgbDate | null = null;
  activeTab = 'none';
  priceTab= 'none';
  @Input() productsInfo:any;
  @Input() price:number;
  @Input() indexPrice:number;
  @Input() tabName: any;
  @Input() selectProduct:any;
  @Input() productsEntry:any;
  @Input() dischargePortshw:any;
  @Input() quantityshw:any;
  @Input() quantity:any;
  @Input() value:any;
  priceVal: any;
  a:any;
  productInfo:any;
  COI: boolean =false;
  ITB: boolean= false;
  OpenNegotiation:boolean=true;
  isHidden = false;
  IndexPriceEmpty: boolean;
  FixedPriceEmpty: boolean;
  defaultValue:any= null; 
  displayFixedQPSection =false;
  priceModel: any;
  QPValuSelectedError: boolean = false;
  constructor(private CustomProductsService:CustomProductsService,private config:NgbDatepickerConfig,public ActiveModal: NgbActiveModal,public ModalService:NgbModal,private modalService: NgbModal) { 
    const current = new Date();
    config.minDate = { 
                       year:current.getFullYear(),month:
                       current.getMonth()+1,day:current.getDate()
                    };
    config.outsideDays='hidden';
  }
  ngOnInit(): void {
   
this.productInfo=this.productsInfo;
if (this.productInfo?.combinedTenders.length ==1){
  this.a=this.productInfo?.combinedTenders[0];
  if(this.a.pricingOptionsEnum[0].pricingOptions == 'FIXED_PRICE'){
    this.priceModel = this.price;
  }
  else{
    this.priceModel = this.indexPrice;
  }
  console.log(this.a);
      }else{
        this.productInfo=this.selectProduct;
        this.a=this.productsEntry[0]; 
      }
    
      this.activeTab = this.tabName ? this.tabName : 'none';
      this.priceTab = this.tabName ? this.tabName : 'none';
      this.form = new UntypedFormGroup({
        secondDateRange: new UntypedFormControl(),
        finalQPFromDate: new UntypedFormControl(this.a.finalQPFromDate ? this.a.finalQPFromDate : null),
        finalQPToDate: new UntypedFormControl(this.a.finalQPToDate ? this.a.finalQPToDate : null)
      });
      this.qpStartDt=this.a?.finalQPFromDate? this.changeStartEndDate(this.a?.finalQPFromDate) : null;
      this.qpEndDt=this.a?.finalQPToDate ?this.changeStartEndDate(this.a?.finalQPToDate) : null;
      this.form.controls['finalQPFromDate'].setValue(this.qpStartDt);
      this.form.controls['finalQPToDate'].setValue(this.qpEndDt);
      console.log(this.qpStartDt,'qpStartDt')
      console.log(this.qpEndDt,'qpEndDt')
      if(this.quantity){
        this.value=this.quantity
      }else{
        this.value=this.a.maximumQuantity
      }
  }
  toolTipShow(){
    this.isHidden = true;
    const hover = document.getElementById('differential_values');
    if(hover) hover.style.display = 'block';
  }
  toolTipHide(){
    this.isHidden = false;
    const hover = document.getElementById('differential_values');
    if(hover) hover.style.display = 'none';
  }
  changeStartEndDate(date){
    var laycanDate = this.getDateinCorrectFormat(date);
    return laycanDate;
  }
  getDateinCorrectFormat(selectedDate){
    var formattedDate = new Date(selectedDate).getDate() + '-' + (new Date(selectedDate).getMonth()+1) + '-' + new Date(selectedDate).getFullYear();
    return formattedDate;
  }
  setTitle(value){
    switch(value){
      case "Select year": return this.selectYear;
      case "Select month": return this.selectMonth;
      case "Next month": return this.nextMonth;
      case "Previous month": return this.preMonth;
      default : return;
    }
  }
  toggle(data: any) {
    data.toggle();
    let element3 = document.getElementsByClassName("btn btn-link ngb-dp-arrow-btn");
    for(let i=0;i<element3.length;i++){
      let value = element3[i].getAttribute("title");
      console.log(value);
      element3[i].setAttribute("title",this.setTitle(value));
    }

   let element4 = document.getElementsByTagName("ngb-datepicker-navigation-select")[0].children;
   for(let i=0;i<element4.length;i++){
      let value = element4[i].getAttribute("title");
      element4[i].setAttribute("title",this.setTitle(value))
   }
  }
  checkPad(d) {
    return (d < 10) ? '0' + d.toString() : d.toString();
}
  defaultDate(){
    let date = new Date();
    this.convertedDate = date.getFullYear() + '-' + (date.getMonth()+1) + '-' + date.getDate();
  }
  qpFromDateSelection(selectedDate) {
    if(selectedDate == null){
      this.QPstartDate = null;
      this.QPendDate = null;
     }
     else{
      this.isFinalQPFromDateValid=false;
     this.defaultDate();
    //  this.counterOfferError = false;
    //  this.counterOfferErrorValue = '';
    //  this.showDateError = false;
     this.QPstartDate = selectedDate;
    this.QPendDate=selectedDate
     this.convertedDate = selectedDate;
     this.convertedDate = selectedDate.year + '-' + this.checkPad(selectedDate.month) + '-' + this.checkPad(selectedDate.day);
     const dateTime = moment(this.convertedDate, + '00:00' + 'YYYY-MM-DD HH:mm');
     this.qpSD=dateTime.format();
     }
  }
  qpChangeAction(event:any, index, options:any){   
    this.QPValuSelectedError = false;
    options.pricingOptionsEnum[0].qp=[];    
    if(event.target.value === 'Fixed QP'){     
      this.displayFixedQPSection = true;
    }else{
      this.displayFixedQPSection = false;
    }
    let valueSelected = options.pricingOptionsEnum[0].qpMultipleChoices.find(x=>x.description == event.target.value);
    
    options.pricingOptionsEnum[0].qp.push(valueSelected);
    // options.qp.push({"description": event.target.value, "uniqueRowNumber":event.currentTarget.options[event.currentTarget.options.selectedIndex].id})
  }
  checkifQPisselected(){
    let isOneQPSelected = false;
    if(this.a.isQPMultipleChoicesSelected==true){
     if(this.a.pricingOptionsEnum[0].qp){
      if(this.defaultValue=='' || this.defaultValue == null){
        isOneQPSelected = false;
      }
      else{
        isOneQPSelected = true;
      }
     }
     else{
      isOneQPSelected = false;
     }
    }
    else{
      isOneQPSelected = true; 
    }
    return isOneQPSelected;

  }
  qpToDateSelection(selectedDate){
    if(selectedDate == null){
      this.QPstartDate = null;
      this.QPendDate = null;
     }
     else{
      this.isFinalQPToGreater=false;
      this.isFinalQPToDateValid=false;
     this.defaultDate();
    //  this.counterOfferError = false;
    //  this.counterOfferErrorValue = '';
    //  this.showDateError = false;
     this.QPstartDate = selectedDate;
    this.QPendDate=selectedDate
     this.convertedDate = selectedDate;
     this.convertedDate = selectedDate.year + '-' + this.checkPad(selectedDate.month) + '-' + this.checkPad(selectedDate.day);
     const dateTime = moment(this.convertedDate, + '00:00' + 'YYYY-MM-DD HH:mm');
     this.qpED=dateTime.format();
     }
  } 
  checkPriceValidation($event){
    // tslint:disable-next-line:prefer-const
    let s = $event.target.value.split('.');
    if (s.length === 1){
      if (s[0].length >= 6) {
        $event.preventDefault();
      }
    }
  }
  changeTab(data):any{
    this.activeTab = data;
    if (this.activeTab === 'fixedprice') {
      this.priceTab = 'fixedprice'
    }
    else if (this.activeTab === 'indexprice') {
      this.priceTab = 'indexprice'
    }
  }
  close(): any {
    this.ActiveModal.close();
  }
  checkpriceEnteredorNot() {
    if ((this.a.pricingOptionsEnum[0].pricingOptions == 'INDEX_PRICE' || 
          this.a.pricingOptionsEnum[0].pricingOptions == 'LUMP_FIXED_PRICE' ||this.a.pricingOptionsEnum[0].pricingOptions=='FIXED_PREMIUM' )) {
      if (this.productInfo.commodityType != 'IO') {
        if (this.a.childList == undefined) {
          if (this.priceModel == 0 || this.priceModel == undefined) {
            this.IndexPriceEmpty = true;
          }
          else {
            this.IndexPriceEmpty = false;
          }
          return this.IndexPriceEmpty;
        }
        else {
          this.a.childList.forEach(x => {
            if (x.indexPriceshw == 0 || x.indexPriceshw == undefined || x.indexPriceshw == '') {
              x.IndexPriceEmpty = true;
            }
            else {
              x.IndexPriceEmpty = false;
            }
          });
          if (this.a.childList.filter(x => { return x.IndexPriceEmpty == true }).length > 0) {
            this.IndexPriceEmpty = true;
          }
          else {
            this.IndexPriceEmpty = false;
          }
          return this.IndexPriceEmpty;
        }
      }
      else {
        this.IndexPriceEmpty = false;
        return this.IndexPriceEmpty;
      }

    }
    else if(this.a.pricingOptionsEnum[0].pricingOptions == 'FIXED_PRICE') {
      if (this.a.childList == undefined) {
        if (this.priceModel == 0 || this.priceModel == undefined) {
          this.FixedPriceEmpty = true;
        }
        else {
          this.FixedPriceEmpty = false;
        }
        return this.FixedPriceEmpty;
      }
      else {
        this.a.childList.forEach(x => {
          if (x.priceshw == 0 || x.priceshw == undefined || x.priceshw == '') {
            x.FixedPriceEmpty = true;
          }
          else {
            x.FixedPriceEmpty = false;
          }
        });
        if (this.a.childList.filter(x => { return x.FixedPriceEmpty == true }).length > 0) {
          this.FixedPriceEmpty = true;
        }
        else {
          this.FixedPriceEmpty = false;
        }
        return this.FixedPriceEmpty;
      }
    }
    else{
      this.FixedPriceEmpty = false;
      this.IndexPriceEmpty = false;
      return this.FixedPriceEmpty;
    }
  }
   
    checkQPdateValidation(){
      let flag: boolean;
        //to check to and from date required
        if( this.form.value.finalQPToDate == '' || this.form.value.finalQPToDate == null){
          this.isFinalQPToDateValid = true;
          //flag = this.isFinalQPToDateValid;
        }
        if(this.form.value.finalQPFromDate == '' || this.form.value.finalQPFromDate ==null){
          this.isFinalQPFromDateValid = true;
        // flag = this.isFinalQPToDateValid;
        }
      // to check to date is grater than from date
        if(!this.isFinalQPToDateValid && !this.isFinalQPFromDateValid){
          let formattedFromDate = this.CustomProductsService.convertDateIntoYYYYMMDDFormat(this.form.value.finalQPFromDate);
          let formattedToDate = this.CustomProductsService.convertDateIntoYYYYMMDDFormat(this.form.value.finalQPToDate);
    
          if(moment(formattedToDate).isBefore(moment(formattedFromDate),'day')){
            this.isFinalQPToGreater=true;
            this.form.value.finalQPToDate = '';
          }else{
            this.isFinalQPToGreater=false;
          }
        }
        flag = this.isFinalQPToGreater || this.isFinalQPFromDateValid || this.isFinalQPToDateValid;
  

     
      return  flag;
    }
  
  
  Openmodal() {
    let dateValidationCheck: boolean;

    if (this.productInfo.combinedTenders[0].isQuotationPeriodUnrestricted
      && (this.productInfo.combinedTenders[0].finalQPToDate != 'undefined' || this.productInfo.combinedTenders[0].finalQPToDate != '' || this.productInfo.combinedTenders[0].finalQPToDate != null) && (this.productInfo.combinedTenders[0].finalQPFromDate != 'undefined' || this.productInfo.combinedTenders[0].finalQPFromDate != '' || this.productInfo.combinedTenders[0].finalQPFromDate != null)) {
      if ((this.productInfo.combinedTenders[0].pricingOptionsEnum.length == 1 && (this.productInfo.combinedTenders[0].pricingOptionsEnum[0].pricingOptions == 'INDEX_PRICE' || this.productInfo.combinedTenders[0].pricingOptionsEnum[0].pricingOptions == 'LUMP_FIXED_PRICE'))) {
        dateValidationCheck = this.checkQPdateValidation();
      } else if (this.productInfo.combinedTenders[0].pricingOptionsEnum.length > 1 && this.priceTab != 'FIXED_PRICE') {
        dateValidationCheck = this.checkQPdateValidation();
      } else {
        dateValidationCheck = false;
      }
    } else {
     // dateValidationCheck = false;
     if(this.a.pricingOptionsEnum[0].qp){
      if(this.a.pricingOptionsEnum[0].qp[0].description == 'Fixed QP' && (this.form.value.finalQPFromDate == undefined || this.form.value.finalQPToDate == undefined)){
        this.defaultValue = this.a.pricingOptionsEnum[0].qp[0].description;
        this.isFinalQPFromDateValid = true;
        this.isFinalQPToDateValid = true;
        this.displayFixedQPSection =true;
        dateValidationCheck = true;
      } else{        
        dateValidationCheck =false;
      }
    }else{
      dateValidationCheck = false;
    }
    }
    let proceedFurther: boolean = this.checkpriceEnteredorNot();
    let QPValuSelectedlocal = this.checkifQPisselected();

    if (!proceedFurther && !dateValidationCheck && QPValuSelectedlocal == true) {
      const ModalRef = this.modalService.open(EditConfirmBidComponent, { centered: true, size: 'sm' });
      ModalRef.componentInstance.finalQPFromDate = this.qpSD ? this.qpSD : this.a.finalQPFromDate;
      ModalRef.componentInstance.finalQPToDate = this.qpED ? this.qpED : this.a.finalQPToDate;
      ModalRef.componentInstance.dischargePortshw = this.dischargePortshw;
      ModalRef.componentInstance.quantityshw = this.quantityshw;
      if (this.productInfo?.combinedTenders.length == 1) {
        ModalRef.componentInstance.datePeriod = this.productInfo;
        ModalRef.componentInstance.code = this.productInfo?.combinedTenders[0];
        ModalRef.componentInstance.price = this.priceModel;
        if (this.a.maximumQuantity && this.a.minimumQuantity) {
          ModalRef.componentInstance.quantity = this.value;
        }
      } else {
        ModalRef.componentInstance.datePeriod = this.selectProduct;
        ModalRef.componentInstance.code = this.productsEntry;
        ModalRef.componentInstance.price = this.price;
        if (this.a.maximumQuantity && this.a.minimumQuantity) {
          ModalRef.componentInstance.quantity = this.value;
        }

      }
      this.ActiveModal.close();
    }    else{
      if(QPValuSelectedlocal == false){
        this.QPValuSelectedError = true;
      }
      else{
        this.QPValuSelectedError = false;
      }
    }

  }
  omit_special_char(event)
  {   
     var k;  
     k = event.charCode;  //         k = event.keyCode;  (Both can be used)
     return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || k==46 ||(k >= 48 && k <= 57)); 
    }
    Omit_Special_Char(event)
  {   
     var k;  
     k = event.charCode;  //         k = event.keyCode;  (Both can be used)
     return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32|| k==45 || k==46 ||(k >= 48 && k <= 57)); 
    }
    decimalFilter(event: any) {
    const reg = /^-?\d*(\.\d{0,4})?$/;
    let input = event.target.value + String.fromCharCode(event.charCode);
  
    if (!reg.test(input)) {
        event.preventDefault();
    }
    }
    getPricingBasisBasedOnOption(pricingOption,description){
      return this.CustomProductsService.getPricingBasisBasedOnOption(pricingOption,description)
    }
    formatQPDates(data){
      return this.CustomProductsService.formatQPDates(data);
    }
    changeQuantity(action,step){
      let currentValue;
      if(action == 'decrease'){
        currentValue = this.value - 5000;
        currentValue >= this.a.minimumQuantity? this.value = currentValue: this.value;
        
      }else if(action == 'increase'){
        currentValue= this.value + 5000;
        currentValue <= this.a.maximumQuantity? this.value = currentValue : this.value;
      }
    }
    getPrefix(priceOptions,commodityType){
      return this.CustomProductsService.getPrefix(priceOptions,commodityType)
    
    }
    getLabel(priceOptions,commodityType){
      return this.CustomProductsService.getLabel(priceOptions,commodityType);
    }
    getUnit(priceOptions,commodityType){
      return this.CustomProductsService.getUnit(priceOptions,commodityType);
    }

}
